import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { LoaderService } from '@shared/services/loader.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-global-spinner',
  imports: [CommonModule, MatProgressSpinner],
  templateUrl: './global-spinner.component.html',
  styleUrl: './global-spinner.component.css',
})
export class GlobalSpinnerComponent {
  loaderService = inject(LoaderService);

  loading$: Observable<boolean>;

  constructor() {
    this.loading$ = this.loaderService.loading$;
  }
}
